<template>
	<div class="mo-forms">

		<div class="input-wrapper">
			<span
				v-if="instruction"
				class="instruction"
			>
				{{ instruction }}
			</span>
			<slot />
		</div>

		<div class="form-actions">
			<slot name="actions" />
			<slot name="submitResponse" />
		</div>



	</div>
</template>

<script>
export default {
	name: 'MoForms',
	props: {
		title: {
			type: String,
			default: null
		},
		instruction: {
			type: String,
			default: null
		}
	}
}
</script>


<style lang="scss" scoped>
@import "../assets/sass/variables";
@import "../assets/sass/media-queries";

.mo-forms {
	max-width: 70.18rem;
	margin: 0 auto;
	display: flex;
	flex-direction: column;

	@include max-screen($small) {
		padding-left: 2rem;
		padding-right: 2rem;
	}

	background: $color-white;
	border-radius: $border-radius;
	box-shadow: $box-shadow;
	padding-top: 5rem;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;

	.input-wrapper {

		max-width: 42rem;
		position: relative;

		.instruction {
			display: block;
			color: $color-text;
			font-size: 2.4rem;
			font-weight: 400;
			letter-spacing: 0.3rem;
			margin-bottom: 5rem;
			text-transform: uppercase;
			text-align: center;
		}

		/deep/ .el-input {
			margin-bottom: 3.2rem;
		}

		a, p, label {
			font-size: 1.2rem;
			line-height: 2.3rem;
		}

		a {
			color: $color-main;
			text-decoration: underline;
		}
	}

	.form-actions {
		display: flex;
		flex-direction: column;
		justify-content: center;
		margin: 5rem 0;

		@include max-screen($xsmall) {
			justify-content: center;
			align-items: center;
			flex-direction: column;
			/deep/ .el-button {
				margin: 1rem 0;
			}
		}
	}

}
</style>
